import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { Location } from '@hetivo/hetivo-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createLocationApi, locationKeys } from '../api';
import type { UpdateLocationParams } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUpdateLocation(locationId: string): UseMutationResult<Location, Error, UpdateLocationParams> {
  const client = useApiClient('admin-auth');
  const api = createLocationApi(client);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateLocationParams) => api.updateLocation(locationId, params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: locationKeys.all });
    },
  });
}
